module.exports = __webpack_public_path__ + "img/img3@2x.d621de94.png";